export default {
  root: {
    padding: "9px"
  }
};
